import { AxiosInstance } from 'axios';
import Assistant from '@curity/oauth-assistant';


export interface GenericState<T = any> {
    loading: boolean,
    error: boolean
    data: T
}

export function initializeGenericState<T = any>(): GenericState<T> {
    return {
        loading: false,
        error: false,
        data: null
    }
}

export const initialGenericState = initializeGenericState();
export interface IThunkArguments {
    sandboxAxiosInstance: AxiosInstance,
    productionAxiosInstance: AxiosInstance
    assistant: Assistant,
    silentAssistant: Assistant
}

export enum TPPMessageCode {
    SUCCESS = 0O0,
    FAILED = 1000

}
export interface IVerifyTppEmailResponse extends Response {
    attributes: {
        status: TPPMessageCode,
        message: string,
        id: string,
    }
}


export type IWebPortalProps = 'dataManagement'
    | 'sandboxAPI'

export type ISandboxAPIProps =
    'products'
    | 'userApplications'
    | 'selectedApplication'
    | 'deleteApplicationStatus'
    | 'createApplicationResult'
    | 'createTokenResult'
    | 'userTPPs'
    | 'selectedTPP'

export type IProductionAPIProps =
    //'products'
    //| 'userApplications'
    'selectedApplication'
    //| 'deleteApplicationStatus'
    //| 'createApplicationResult'
    | 'userTPPs'
    | 'products'

export type IDataManagementProps =
    'fakePersonData'
    | 'reservation'
    | 'reservedPersonData'
    | 'reservedIndividual'
    | 'accounts'
    | 'selectedAccount'
    | 'generationResult'
    | 'transactions'
    | 'unreservedResult'
    | 'cards'

export type IRootReducerProps =
    'developerState'
    | 'createDeveloperState'

export interface ISandboxAPIAccess {
    area: 'sandboxAPI',
    state: ISandboxAPIProps
}

export interface IProductionAPIAccess {
    area: 'productionAPI',
    state: IProductionAPIProps
}
export interface IDataManagementAccess {
    area: 'dataManagement'
    state: IDataManagementProps
}

export interface IRotReducerAccess {
    area: undefined,
    state: IRootReducerProps
}
